<template>
    <div class="skills">
        <h5 class="title">Vaardigheden</h5>
        <ul class="skills-list">
            <li class="skill" v-for="skill of skillsIn" :key="skill.id">
                <design-2021-workflow-show-skill-progress-component :skill-in="skill">
                </design-2021-workflow-show-skill-progress-component>
            </li>
        </ul>
    </div>

</template>

<script>
export default {
    name: "workflow-detail-assignment-skills-component",
    props: {
        skillsIn: {
            type: Array,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
    .skills {
        flex: 1 1 calc(25% - 30px);
    }

    .skills-list {
        padding-left: 0;
        display: flex;
        flex-direction: column;
        row-gap: map-get($grid-gutter-spacing, 'ten');
        margin-bottom: 0;

        .skill {
            list-style: none;
            width: 100%;
        }
    }
</style>
